import { IStateProvider } from 'angular-ui-router';

NewSdcRouteConfig.$inject = ['$stateProvider'];

export function NewSdcRouteConfig($stateProvider: IStateProvider) {
  $stateProvider.state('main.school.new-sdc', {
    abstract: true,
    template: '<div ui-view></div>',
    onEnter($window, SDCStore) {
      // For debugging
      $window.SDCStore = SDCStore;
    },
  });
}
